import React from 'react'
import { Link } from 'gatsby'
import { MembershipsQuery, getHTML } from '../../core'

import './memberships.scss'

const Membership = ({ 
  title, 
  slug, 
  baseCost, 
  shortDescription, 
  pricingMethod,
}) => (
  <Link styleName='membership' to={`/memberships/${slug}`}>
    <h4 styleName="title">{title}</h4>
    <div styleName="description" dangerouslySetInnerHTML={getHTML(shortDescription)} />
    <h5><b>From ${baseCost} / {pricingMethod}</b></h5>
  </Link>
)

const MembershipsSection = ({ data = {}, context = {} }) => {
  const { 
    image,
    membershipOptions,
  } = data

  const imageSrc = image && image.file && image.file.url

  return (
    <section styleName="memberships-wrapper">
      {image && <img src={imageSrc} />}

      <MembershipsQuery
        render={({ data: membershipsData = {} }) => {
          const { memberships } = membershipsData

          const membershipsToShow = membershipOptions 
            ? membershipOptions.map(
              membership => ({
                ...membership,
                ...memberships.find(m => m.id === membership.id),
              })
            )
            : memberships || []

          return (
            <div styleName='memberships'>
              {membershipsToShow
                .filter(m => !m.hideFromPages)
                .map(({ id, ...rest }) => (
                  <Membership key={id} {...rest} />
                ))}
            </div>
          )
        }}
      />
    </section>
  )
}

export default MembershipsSection